import type { ComponentPropsWithoutRef, ReactNode } from "react";
import classNames from "classnames";

export interface HeaderProps extends ComponentPropsWithoutRef<"header"> {
  children: ReactNode;
  className?: string;
}

export const Header = ({ children, className, ...rest }: HeaderProps) => (
  <header
    className={classNames(
      "text-default bg-primary border-primary z-[50] col-span-3 flex h-[3.5rem] w-full flex-row items-center overflow-x-auto px-4 [grid-area:header]",
      className,
    )}
    {...rest}
  >
    {children}
  </header>
);
